export const COLUMN_ID_WIDTH = 100
export const COLUMN_NAME_WIDTH = 150